import React, { useEffect, useState } from "react";
import { collection, getDocs, deleteDoc, doc, updateDoc, query, where, limit } from "firebase/firestore";
import { db } from "../../firebase";
import { useNavigate } from "react-router-dom";

export default function VendorList() {
  const navigate = useNavigate();

  const [vendors, setVendors] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  const fetchVendors = async () => {
    try {
      const user      = JSON.parse(localStorage.getItem("user") || "{}");
      const companyId = user?.company_id || "";
      if (!companyId) return;
      const querySnapshot = await getDocs(
        query(collection(db, "vendors"), where("company_id", "==", companyId))
      );

      const vendorData = querySnapshot.docs.map((docItem) => ({
        id: docItem.id,
        ...docItem.data(),
      }));

      setVendors(vendorData);
    } catch (error) {
      console.error("Error fetching vendors:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVendors();
  }, []);

  const handleDeleteVendor = async (vendorId) => {
    // D-289 Phase 2: a vendor with purchase orders, bills or payments can
    // never be deleted — its khaata would lose its name and old POs would
    // point to nobody. Deactivate keeps every record intact. A vendor with
    // no records (e.g. created by mistake) can still be deleted.
    try {
      const user      = JSON.parse(localStorage.getItem("user") || "{}");
      const companyId = user?.company_id || "";
      const hasAny = async (col, field) => !(await getDocs(query(
        collection(db, col),
        where("company_id", "==", companyId),
        where(field, "==", vendorId),
        limit(1)
      ))).empty;
      if (await hasAny("purchase_orders", "vendor_id")
       || await hasAny("financial_transactions", "vendor_id")
       || await hasAny("financial_transactions", "party_id")) {
        alert("This vendor has purchase orders, bills or payments, so it cannot be deleted. Use Deactivate instead — all its records and its khaata stay safe.");
        return;
      }
    } catch (checkErr) {
      console.error("Vendor delete check failed:", checkErr);
      alert("Could not check this vendor's records. Please try again.");
      return;
    }

    const confirmDelete = window.confirm(
      "Are you sure you want to delete this vendor?"
    );

    if (!confirmDelete) return;

    try {
      await deleteDoc(doc(db, "vendors", vendorId));
      fetchVendors();
      alert("Vendor deleted successfully");
    } catch (error) {
      console.error("Delete Vendor Error:", error);
      alert("Failed to delete vendor");
    }
  };

  const handleToggleStatus = async (vendor) => {
    try {
      await updateDoc(doc(db, "vendors", vendor.id), {
        status: vendor.status === "active" ? "inactive" : "active",
      });

      fetchVendors();
    } catch (error) {
      console.error("Status Update Error:", error);
      alert("Failed to update vendor status");
    }
  };

  const handleEditVendor = (vendorId) => {
    navigate(`/vendor-master?id=${vendorId}`);
  };

  const filteredVendors = vendors.filter(
    (vendor) =>
      vendor.vendor_name?.toLowerCase().includes(search.toLowerCase()) ||
      vendor.vendor_code?.toLowerCase().includes(search.toLowerCase()) ||
      vendor.phone?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="container mt-4">
      <h2>Vendor List</h2>

      <div className="mb-3">
        <input
          type="text"
          placeholder="Search by name / code / phone"
          className="form-control"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {loading ? (
        <p>Loading vendors...</p>
      ) : (
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead className="table-dark">
              <tr>
                <th>Vendor Code</th>
                <th>Vendor Name</th>
                <th>Contact Person</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Type</th>
                <th>Status</th>
                <th>City</th>
                <th>State</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {filteredVendors.length > 0 ? (
                filteredVendors.map((vendor) => (
                  <tr key={vendor.id}>
                    <td>{vendor.vendor_code}</td>
                    <td>{vendor.vendor_name}</td>
                    <td>{vendor.contact_person}</td>
                    <td>{vendor.phone}</td>
                    <td>{vendor.email}</td>
                    <td>{vendor.type}</td>
                    <td>{vendor.status}</td>
                    <td>{vendor.city}</td>
                    <td>{vendor.state}</td>

                    <td className="py-2">
                      <div className="flex gap-2">
                        <button
                          onClick={() => handleEditVendor(vendor.id)}
                          className="px-2 py-1 bg-blue-500 text-white rounded"
                        >
                          Edit
                        </button>

                        <button
                          onClick={() => handleDeleteVendor(vendor.id)}
                          className="px-2 py-1 bg-red-500 text-white rounded"
                        >
                          Delete
                        </button>

                        <button
                          onClick={() => handleToggleStatus(vendor)}
                          className={`px-2 py-1 rounded text-white ${
                            vendor.status === "active"
                              ? "bg-yellow-500"
                              : "bg-green-500"
                          }`}
                        >
                          {vendor.status === "active"
                            ? "Deactivate"
                            : "Activate"}
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="10" className="text-center">
                    No vendors found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}